export const mockPharmacyData = [
  {
    id: 1,
    sources: ["Prescription", "Administration"],
    status: "Pending",
    date: "2026-07-17",
    time: "13:40",
    facility: "Consult Room 1",
    veterinarian: "Dr. Vivek",
    patientName: "Blacky",
    gender: "male",
    breed: "Alaskan Husky",
    ownerName: "Sanjeev",
    itemsSummary: "2 to dispense · 1 to transfer",
    itemsList: [
      { name: "Amoxicillin", qty: 2, action: "Dispense" },
      { name: "Dewormer", qty: 1, action: "Transfer" }
    ],
    statusBadges: ["SCHEDULED"],
    actionButtons: ["Dispense", "Transfer"],
    dispenseCount: 2,
    transferCount: 1,
    // Details mock data
    age: "6 years",
    weight: "13 KG",
    ownerEmail: "sanjeev@yopmail.com",
    ownerPhone: "9787563739",
    caseId: "830",
    consultationType: "Consultation",
    consumables: [
      {
        id: "c1",
        name: "Syringe 5ml",
        batchNumber: "BCH001",
        quantity: 2,
        status: "Pending",
        reason: "—"
      }
    ],
    administration: [
      {
        id: "a1",
        name: "Pain relief",
        batchNumber: "BCH002",
        dosage: "1 ml",
        route: "IV",
        status: "Pending"
      },
      {
        id: "a2",
        name: "Sedative",
        batchNumber: "BCH003",
        dosage: "0.5 ml",
        route: "IM",
        status: "Pending",
        isScheduled: true
      }
    ]
  },
  {
    id: 2,
    sources: ["Prescription"],
    status: "Pending",
    date: "2026-07-17",
    time: "09:00",
    facility: "Consult Room 1",
    veterinarian: "Dr. Vivek",
    patientName: "Max",
    gender: "male",
    breed: "Labrador",
    ownerName: "Rahul",
    itemsSummary: "3 items",
    itemsList: [{ name: "Antibiotics", qty: 3, action: "Dispense" }],
    statusBadges: [],
    actionButtons: ["Dispense"],
    dispenseCount: 3,
    transferCount: 0,
    // Details mock data
    age: "3 years",
    weight: "30 KG",
    ownerEmail: "rahul@yopmail.com",
    ownerPhone: "9876543210",
    caseId: "831",
    consultationType: "Consultation",
    consumables: [
      {
        id: "c2",
        name: "Cannula 22G",
        batchNumber: "BCH004",
        quantity: 1,
        status: "Pending",
        reason: "—"
      }
    ],
    administration: [
      {
        id: "a3",
        name: "Antibiotics Injection",
        batchNumber: "BCH005",
        dosage: "500 mg",
        route: "IV",
        status: "Pending"
      }
    ]
  },
  {
    id: 3,
    sources: ["Refill"],
    status: "Pending",
    date: "2026-07-17",
    time: "11:00",
    facility: null,
    veterinarian: "Dr. Vivek",
    patientName: "Rex",
    gender: "male",
    breed: "German Shepherd",
    ownerName: "Amit",
    itemsSummary: "2 items · Customer refill request",
    itemsList: [{ name: "Refill Medicine", qty: 2, action: "Dispense" }],
    statusBadges: [],
    actionButtons: ["Dispense"],
    dispenseCount: 2,
    transferCount: 0,
    // Details mock data
    age: "5 years",
    weight: "35 KG",
    ownerEmail: "amit@yopmail.com",
    ownerPhone: "9123456789",
    caseId: "832",
    consultationType: "Refill Request",
    consumables: [],
    administration: [
      {
        id: "a4",
        name: "Heartworm Pill",
        batchNumber: "BCH006",
        dosage: "1 tab",
        route: "PO",
        status: "Pending"
      }
    ]
  },
  {
    id: 4,
    sources: ["Prescription"],
    status: "Pending",
    date: "2026-07-17",
    time: "10:15",
    facility: "Consult Room 2",
    veterinarian: "Dr. Supervet",
    patientName: "Whiskers",
    gender: "female",
    breed: "Domestic Shorthair",
    ownerName: "Priya",
    itemsSummary: "2 items",
    itemsList: [{ name: "Ophthalmic Drops", qty: 2, action: "Dispense" }],
    statusBadges: ["SCHEDULED"],
    actionButtons: ["Dispense"],
    dispenseCount: 2,
    transferCount: 0,
    // Details mock data
    age: "2 years",
    weight: "4.5 KG",
    ownerEmail: "priya@yopmail.com",
    ownerPhone: "9812345670",
    caseId: "833",
    consultationType: "Consultation",
    consumables: [],
    administration: [
      {
        id: "a5",
        name: "Eye Drops",
        batchNumber: "BCH007",
        dosage: "2 drops",
        route: "Ocular",
        status: "Pending",
        isScheduled: true
      }
    ]
  },
  {
    id: 5,
    sources: ["Administration"],
    status: "Pending",
    date: "2026-07-17",
    time: "14:00",
    facility: "Surgery",
    facilityNotes: "Surgery — not in stock",
    veterinarian: "Dr. Supervet",
    patientName: "Buddy",
    gender: "male",
    breed: "Golden Retriever",
    ownerName: "Neha",
    itemsSummary: "1 item · Transfer to Surgery",
    itemsList: [{ name: "IV Fluids", qty: 1, action: "Transfer" }],
    statusBadges: [],
    actionButtons: ["Transfer"],
    dispenseCount: 0,
    transferCount: 1,
    // Details mock data
    age: "4 years",
    weight: "28 KG",
    ownerEmail: "neha@yopmail.com",
    ownerPhone: "9876123450",
    caseId: "834",
    consultationType: "Surgery Prep",
    consumables: [
      {
        id: "c3",
        name: "Infusion Set",
        batchNumber: "BCH008",
        quantity: 1,
        status: "Pending",
        reason: "Out of Stock"
      }
    ],
    administration: [
      {
        id: "a6",
        name: "IV Saline",
        batchNumber: "BCH009",
        dosage: "500 ml",
        route: "IV",
        status: "Pending"
      }
    ]
  },
  {
    id: 6,
    sources: ["Administration"],
    status: "Pending",
    date: "2026-07-17",
    time: "15:30",
    facility: "OT",
    facilityNotes: "OT — not in stock",
    veterinarian: "Dr. Vivek",
    patientName: "Rocky",
    gender: "male",
    breed: "Boxer",
    ownerName: "Kiran",
    itemsSummary: "1 item",
    itemsList: [{ name: "Sedative Pill", qty: 1, action: "Transfer" }],
    statusBadges: ["RESTRICTED"],
    actionButtons: ["Transfer"],
    dispenseCount: 0,
    transferCount: 1,
    // Details mock data
    age: "7 years",
    weight: "25 KG",
    ownerEmail: "kiran@yopmail.com",
    ownerPhone: "9000123456",
    caseId: "835",
    consultationType: "Anesthesia",
    consumables: [],
    administration: [
      {
        id: "a7",
        name: "Sedative Injection",
        batchNumber: "BCH010",
        dosage: "2 ml",
        route: "IM",
        status: "Pending"
      }
    ]
  },
  {
    id: 7,
    sources: ["Prescription"],
    status: "Completed",
    date: "2026-07-17",
    time: "08:30",
    facility: "Consult Room 1",
    veterinarian: "Dr. Vivek",
    patientName: "Tommy",
    gender: "male",
    breed: "Beagle",
    ownerName: "John",
    itemsSummary: "2 items",
    itemsList: [{ name: "Vitamins", qty: 2, action: "Dispense" }],
    statusBadges: [],
    actionButtons: [],
    dispenseCount: 0,
    transferCount: 0,
    // Details mock data
    age: "1 year",
    weight: "10 KG",
    ownerEmail: "john@yopmail.com",
    ownerPhone: "9888776655",
    caseId: "836",
    consultationType: "Puppy Checkup",
    consumables: [],
    administration: [
      {
        id: "a8",
        name: "Multivitamin",
        batchNumber: "BCH011",
        dosage: "1 tab",
        route: "PO",
        status: "Completed"
      }
    ]
  },
  {
    id: 8,
    sources: ["Refill"],
    status: "Completed",
    date: "2026-07-15",
    time: "09:15",
    facility: "Consult Room 2",
    veterinarian: "Dr. Supervet",
    patientName: "Milo",
    gender: "male",
    breed: "Persian Cat",
    ownerName: "Lisa",
    itemsSummary: "1 item",
    itemsList: [{ name: "Refill Capsule", qty: 1, action: "Dispense" }],
    statusBadges: [],
    actionButtons: [],
    dispenseCount: 0,
    transferCount: 0,
    // Details mock data
    age: "8 years",
    weight: "5 KG",
    ownerEmail: "lisa@yopmail.com",
    ownerPhone: "9777665544",
    caseId: "837",
    consultationType: "Refill Request",
    consumables: [],
    administration: [
      {
        id: "a9",
        name: "Chronic Pain Pill",
        batchNumber: "BCH012",
        dosage: "0.5 tab",
        route: "PO",
        status: "Completed"
      }
    ]
  },
  {
    id: 9,
    sources: ["Prescription"],
    status: "Pending",
    date: "2026-07-10",
    time: "16:00",
    facility: "Surgery",
    veterinarian: "Dr. Vivek",
    patientName: "Coco",
    gender: "female",
    breed: "Poodle",
    ownerName: "Gary",
    itemsSummary: "1 item",
    itemsList: [{ name: "Painkiller Injectable", qty: 1, action: "Dispense" }],
    statusBadges: [],
    actionButtons: ["Dispense"],
    dispenseCount: 1,
    transferCount: 0,
    // Details mock data
    age: "4 years",
    weight: "6 KG",
    ownerEmail: "gary@yopmail.com",
    ownerPhone: "9666554433",
    caseId: "838",
    consultationType: "Post-Op Check",
    consumables: [],
    administration: [
      {
        id: "a10",
        name: "Painkiller Injection",
        batchNumber: "BCH013",
        dosage: "1 ml",
        route: "SC",
        status: "Pending"
      }
    ]
  }
];
